import store from "../index";
import { computed } from "vue";

const state = () => ({
  isStatisticLoading: true,
  availableColors: [
    "#e6194b",
    "#3cb44b",
    "#ffe119",
    "#4363d8",
    "#f58231",
    "#911eb4",
    "#46f0f0",
    "#f032e6",
    "#bcf60c",
    "#fabebe",
    "#008080",
    "#e6beff",
    "#9a6324",
    "#fffac8",
    "#800000",
    "#aaffc3",
    "#808000",
    "#ffd8b1",
    "#000075",
    "#808080",
    "#ffffff",
    "#000000", // here is break
    "#F0A3FF",
    "#0075DC",
    "#993F00",
    "#4C005C",
    "#191919",
    "#005C31",
    "#2BCE48",
    "#FFCC99",
    "#808080",
    "#94FFB5",
    "#8F7C00",
    "#9DCC00",
    "#C20088",
    "#003380",
    "#FFA405",
    "#FFA8BB",
    "#426600",
    "#FF0010",
    "#5EF1F2",
    "#00998F",
    "#E0FF66",
    "#740AFF",
    "#990000",
    "#FFFF80",
    "#FFFF00",
    "#FF5005",
  ],
  pieChartData: {
    labels: [],
    datasets: [
      {
        backgroundColor: [],
        data: [],
      },
    ],
  },
  barChartData: {
    labels: [],
    datasets: [],
  },
  horizontalBarChartData: {
    labels: [],
    datasets: [
      {
        label: "",
        backgroundColor: "",
        data: [],
      },
    ],
  },
  barChartClicked: false,
  tableRows: [],
  tableName: String,
  statisticsTableRows: [],
});

const getters = {};

const actions = {};

const mutations = {
  setIsStatisticLoading(state, val) {
    state.isStatisticLoading = val;
  },
  updateFullPieChartData(state, val) {
    state.pieChartData = {
      labels: [],
      datasets: [
        {
          backgroundColor: [],
          data: [],
        },
      ],
    };
    for (let i = 0; i < val.length; i++) {
      if (val[i].label != "Undefined") {
        state.pieChartData.labels.push(val[i].label);

        // This was before, when we could have set random colors
        //state.pieChartData.datasets[0].backgroundColor.push(
        //    '#' + Math.floor(Math.random() * 16777215).toString(16)
        //);
        // Now they want to have them repeating
        state.pieChartData.datasets[0].backgroundColor.push(
          state.availableColors[i]
        );
        state.pieChartData.datasets[0].data.push(val[i].data);
      }
    }
  },
  /*   updateFullBarChartData(state, val) {
    state.barChartData = {
      labels: [],
      datasets: [],
    };

    state.barChartData.labels = val.labels;
    for (let i = 0; i < val.datasets.length; i++) {
      let dataset = {
        label: val.datasets[i].label,

        backgroundColor: state.availableColors[i],
        data: val.datasets[i].data.split(','),
      };

      state.barChartData.datasets.push(dataset);
    }
  },
  updateFullHorizontalBarChartData(state, val) {
    state.horizontalBarChartData = {
      labels: [],
      datasets: [
        {
          label: '',
          backgroundColor: '',
          data: [],
        },
      ],
    };
    state.horizontalBarChartData.datasets[0].label = 'Aantal x aangevraagd';
    state.horizontalBarChartData.datasets[0].backgroundColor = '#264478';

    for (let i = 0; i < val.length; i++) {
      if (val[i].label != 'Undefined') {
        state.horizontalBarChartData.labels.push(val[i].label);
        state.horizontalBarChartData.datasets[0].data.push(val[i].data);

    
      }
    }
  }, */

  updateFullBarChartData(state, val) {
    state.barChartData = {
      labels: [],
      datasets: [],
    };

    state.barChartData.labels = val.labels;

    const labels = val.labels;
    const datasets = val.datasets.map((dataset, index) => {
      const color = state.availableColors[index % state.availableColors.length];
      return {
        label: dataset.label,
        data: dataset.data.map((item) => item.amount),
        backgroundColor: color,
      };
    });

    state.barChartData.labels = labels;
    state.barChartData.datasets = datasets;
    
    const mainCustomer = computed({
      get: () => store.state.fomoStatisticsSearch.selectedMainCustomer,
    });

    var idx = -1;

    if (mainCustomer.value != null) {
      for (let i = 0; i < state.barChartData.datasets.length; i++)
        if (state.barChartData.datasets[i].label == mainCustomer.value.label) {
          idx = i;
          var copy = state.barChartData.datasets[i];
          state.barChartData.datasets.splice(idx, 1);
          state.barChartData.datasets.unshift(copy);
          state.barChartData.datasets[0].backgroundColor = "#264478";
          break;
        }
    }
  },
  updateFullHorizontalBarChartData(state, val) {
    state.horizontalBarChartData = {
      labels: [],
      datasets: [
        {
          label: "",
          backgroundColor: "",
          data: [],
        },
      ],
    };
    state.horizontalBarChartData.datasets[0].label =
      "Totaalbedrag aan verleende subsidie (in euro’s)";
    // state.horizontalBarChartData.datasets[0].backgroundColor = '#' + Math.floor(Math.random() * 16777215).toString(16);
    state.horizontalBarChartData.datasets[0].backgroundColor = "#264478";

    for (let i = 0; i < val.length; i++) {
      if (val[i].label != "Undefined") {
        state.horizontalBarChartData.labels.push(val[i].label);
        state.horizontalBarChartData.datasets[0].data.push(val[i].amountSum);
      }
    }

    const mainCustomer = computed({
      get: () => store.state.fomoStatisticsSearch.selectedMainCustomer,
    });

    var idx = -1;
    if (mainCustomer.value != null && mainCustomer.value.label != "Undefined")
      for (let i = 0; i < state.horizontalBarChartData.labels.length; i++) {
        if (
          state.horizontalBarChartData.labels[i] == mainCustomer.value.label
        ) {
          idx = i;
          var label = state.horizontalBarChartData.labels[i];
          var data = state.horizontalBarChartData.datasets[0].amountSum[i];
          state.horizontalBarChartData.labels.splice(idx, 1);
          state.horizontalBarChartData.labels.unshift(label);
          state.horizontalBarChartData.datasets[0].data.splice(idx, 1);
          state.horizontalBarChartData.datasets[0].data.unshift(data);
        }
      }
  },

  updateBarChartClicked(state, val) {
    state.barChartClicked = val;
  },
  setTableRows(state, val) {
    state.tableRows = val;
  },
  setTableName(state, val) {
    state.tableName = val;
  },

  setStatisticsTableRows(state, val) {
    state.statisticsTableRows = val;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
